
















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import UiButton from 'src/stories/ui-button.vue';
import UiLabel from 'src/stories/ui-label.vue';
import UiChevron from 'src/stories/ui-chevron.vue';
import UiMenu from 'src/stories/ui-menu.vue';
import UiSelect from 'src/stories/ui-select.vue';
import UiTooltipIcon from 'src/stories/ui-tooltip-icon.vue';
import UiInput from 'src/stories/ui-input.vue';
import UiDatePicker from 'src/stories/ui-date-picker.vue';
import UiChip from 'src/stories/ui-chip.vue';
import UiInputTime from 'src/stories/ui-input-time.vue';
import UiDateTimePicker from 'src/stories/ui-date-time-picker.vue';
import UiInfo from 'src/stories/ui-info.vue';
import UiCheckbox from 'src/stories/ui-checkbox.vue';
import UiRadioGroup from 'src/stories/ui-radio-group.vue';
import UiSwitcher from 'src/stories/ui-switcher.vue';
import UiTextarea from 'src/stories/ui-textarea.vue';
import UiIcon from 'src/stories/ui-icon.vue';
import UiUpdateInfo from 'src/stories/ui-update-info.vue';
import UiLogout from 'src/stories/ui-logout.vue';
import UiNotFound from 'src/stories/ui-not-found.vue';
import UiPeriodPicker from 'src/stories/ui-period-picker.vue';
import UiPhoneInput from 'src/stories/ui-phone-input.vue';
import UiTabs from 'src/stories/ui-tabs.vue';
import UiPeriodPickerInput from 'src/stories/ui-period-picker-input.vue';
import UiCopyInput from 'src/stories/ui-copy-input.vue';
import UiCopyTextarea from 'src/stories/ui-copy-textarea.vue';
import UiCountInput from 'src/stories/ui-count-input.vue';
import UiCreateUrlTags from 'src/stories/ui-create-url-tags.vue';
import UiTable from 'src/stories/ui-table.vue';
import UiTreeview from 'src/stories/ui-treeview.vue';

const md5 = require('md5');

const storybookList = {
  UiButton,
  UiLabel,
  UiChevron,
  UiMenu,
  UiSelect,
  UiTooltipIcon,
  UiInput,
  UiDatePicker,
  UiChip,
  UiInputTime,
  UiDateTimePicker,
  UiInfo,
  UiCheckbox,
  UiRadioGroup,
  UiSwitcher,
  UiTextarea,
  UiIcon,
  UiUpdateInfo,
  UiLogout,
  UiNotFound,
  UiPeriodPicker,
  UiPeriodPickerInput,
  UiPhoneInput,
  UiTabs,
  UiCopyInput,
  UiCopyTextarea,
  UiCountInput,
  UiCreateUrlTags,
  UiTable,
  UiTreeview,
}

@Component({
  components: {
    ...storybookList,
  }
})
export default class Storybook extends Vue {
  curTab: string = this.storybookList[0];

  mounted() {
    this.$store.commit('loading', false);
  }

  get storybookList() {
    return Object.keys(storybookList)
  }

}
